import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const MarketingBanner = ({ dismissible }) => {
  const [dismissed, setDismissed] = useState(false);
  const parentEl = useRef(null);
  const hideMarketingBanner =
    typeof window !== 'undefined' &&
    localStorage.getItem('hideMarketingBanner');

  const onDismiss = () => {
    localStorage.setItem('hideMarketingBanner', 'true');
    parentEl.current.classList.toggle(styles.dismissed);
  };

  if (dismissed) return null;
  if (dismissible && hideMarketingBanner === 'true') return null;
  return (
    <p
      ref={parentEl}
      className={styles.banner}
      onAnimationEnd={() => setDismissed(true)}
    >
      <a
        target="_blank"
        className={styles.link}
        href="/welcome/save-on-your-next-office/"
      >
        SquareFoot saves clients an average of 23% on their office space
      </a>
      {dismissible && (
        <button
          type="button"
          onClick={onDismiss}
          id="marketingBannerCloseButton"
          className={styles.dismissButton}
        >
          ×
        </button>
      )}
    </p>
  );
};

MarketingBanner.propTypes = {
  dismissible: PropTypes.bool,
};

MarketingBanner.defaultProps = {
  dismissible: false,
};

export default MarketingBanner;
